import { Card, Divider } from 'antd';

import { Details } from 'business/quality-control/pages/segment-history/components/segment-details-drawer/components/details';
import { useGetDefectPicturesData } from 'business/quality-control/pages/segment-history/components/segment-details-drawer/hooks/data/get-defect-pictures';
import { useGetRepairPicturesData } from 'business/quality-control/pages/segment-history/components/segment-details-drawer/hooks/data/get-repair-pictures';
import { SegmentHistory } from 'business/quality-control/pages/segment-history/hooks/data/types';
import { Picture } from 'ui/pictures';

import styles from './index.module.scss';

const RepairDetails = ({
  historyEntry,
  entryIndex,
  entryNumber,
  refetchData,
  mobile,
  isUserManager,
}: {
  historyEntry: SegmentHistory['history'][number];
  entryIndex: number;
  entryNumber: number;
  refetchData: () => void;
  mobile: boolean;
  isUserManager: boolean;
}) => {
  const { data: repairPicturesData, isLoading } = useGetRepairPicturesData(
    historyEntry.quarantineDefect?.repair?.id,
  );
  const repairPictures: Picture[] = repairPicturesData
    ? repairPicturesData?.pictures.map((item) => ({
        description: item.id,
        path: item.path,
      }))
    : [];

  return (
    <>
      <Divider className={styles.divider} />

      <Details
        entryIndex={entryIndex}
        entryNumber={entryNumber}
        historyEntry={historyEntry}
        pictures={repairPictures}
        isPicturesLoading={isLoading}
        refetchData={refetchData}
        mobile={mobile}
        isUserManager={isUserManager}
      />
    </>
  );
};

export const QuarantineDetails = ({
  historyEntry,
  entryIndex,
  entryNumber,
  refetchData,
  mobile,
  isUserManager,
}: {
  historyEntry: SegmentHistory['history'][number];
  entryIndex: number;
  entryNumber: number;
  refetchData: () => void;
  mobile: boolean;
  isUserManager: boolean;
}) => {
  const { data: defectPicturesData, isLoading } = useGetDefectPicturesData(
    historyEntry.quarantineDefect?.id,
  );
  const defectPictures: Picture[] = defectPicturesData
    ? defectPicturesData?.pictures.map((item) => ({
        description: item.id,
        path: item.path,
      }))
    : [];

  return (
    <Card className={styles.card} variant="borderless">
      <Details
        entryIndex={entryIndex}
        entryNumber={entryNumber}
        historyEntry={historyEntry}
        defect
        pictures={defectPictures}
        isPicturesLoading={isLoading}
        refetchData={refetchData}
        mobile={mobile}
        isUserManager={isUserManager}
      />

      {historyEntry.quarantineDefect?.repair ? (
        <RepairDetails
          entryIndex={entryIndex}
          entryNumber={entryNumber}
          historyEntry={historyEntry}
          refetchData={refetchData}
          mobile={mobile}
          isUserManager={isUserManager}
        />
      ) : null}
    </Card>
  );
};
